<template>
  <div class="col" :id="'tinkListItem_' + _uid">
    <slot></slot>
  </div>
</template>
<script>
import uiUtil from "@/mixins/util.js"

export default {
  name: "tinkListItem",
}
</script>
